import { createSlice } from '@reduxjs/toolkit';

export const studiesSlice = createSlice({
  name: 'studies',
  initialState: {
    userStudies: [],
    isStudyLaunching: false,
  },
  reducers: {
    setUserStudies: (state, action) => {
      state.userStudies = action.payload;
    },
    setIsStudyLaunching: (state, action) => {
      state.isStudyLaunching = action.payload;
    },
  },
});

export const {
  setUserStudies,
  setIsStudyLaunching,
} = studiesSlice.actions;

export default studiesSlice.reducer;
